// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Float from "../../../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as PartnerScoreV2CssHelper from "../../../domain/helper/PartnerScoreV2CssHelper.bs.js";
import * as PartnerScoreAssetManager from "../../assets/PartnerScoreAssetManager.bs.js";
import * as PartnerScoreCommonCssHelper from "../../../domain/helper/PartnerScoreCommonCssHelper.bs.js";

function ScoreMessageBoxV2(Props) {
  var message_box = Props.message_box;
  var max_score = Props.max_score;
  var action_details = Props.action_details;
  return React.createElement("div", {
              className: "score-message-box-container"
            }, React.createElement("div", {
                  className: "score-message-box-tooltip",
                  style: PartnerScoreV2CssHelper.getTooltipStyle(action_details.active_suspension, Belt_Option.getWithDefault(Belt_Float.fromString(action_details.action_threshold), 0), max_score)
                }), React.createElement("div", {
                  className: "score-message-box",
                  style: PartnerScoreCommonCssHelper.getMessageBoxStyle(message_box)
                }, React.createElement("img", {
                      className: "score-message-icon",
                      src: PartnerScoreAssetManager.getImage(message_box.message_box_icon_path)
                    }), React.createElement("div", {
                      className: "score-message-text",
                      style: PartnerScoreCommonCssHelper.getMessageTextColor(message_box)
                    }, action_details.action_text)));
}

var make = ScoreMessageBoxV2;

export {
  make ,
  
}
/* react Not a pure module */
